/* eslint-disable max-len */
import { adminBuildingType, errorType } from '@propTypes';
import FormikBuildingForm from './Form';
import FormikAmenitiesForm from './Form/AmenitiesBuildingForm';
import FormikDataCollectionForm from './Form/DataCollectionBuildingForm';
import Listings from './Listings';
import UnlistedSpaces from './UnlistedSpaces';
import BuildingMediaTable from './BuildingMediaTable';
import BuildingContacts from './BuildingContacts';
import s from './BuildingPage.module.less';

export const TABS = [
  'form',
  'amenities',
  'dataCollection',
  'media',
  'contacts',
  'listedSpaces',
  'unlistedSpaces',
];

type Props = {
  building: adminBuildingType;
  updateBuilding: $TSFixMeFunction;
  currentPage: $TSFixMe; // TODO: PropTypes.oneOf(TABS)
  fetchAdminBuilding: $TSFixMeFunction;
  errors: errorType[];
};
const MenuSwitcher = ({
  building,
  updateBuilding,
  currentPage,
  fetchAdminBuilding,
  errors,
}: Props) => {
  switch (currentPage) {
    case 'form':
      return (
        <section className={s.contentSection}>
          <FormikBuildingForm
            building={building}
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ building: any; errors: any[]; fetchAdminBu... Remove this comment to see the full error message
            errors={errors}
            fetchAdminBuilding={fetchAdminBuilding}
            updateBuilding={updateBuilding}
          />
        </section>
      );
    case 'amenities':
      return (
        <section className={s.contentSection}>
          <FormikAmenitiesForm building={building} updateBuilding={updateBuilding} />
        </section>
      );
    case 'dataCollection':
      return (
        <section className={s.contentSection}>
          <FormikDataCollectionForm building={building} updateBuilding={updateBuilding} />
        </section>
      );
    case 'listedSpaces':
      return (
        <section className={s.contentSection}>
          <Listings buildingId={building.id} />
        </section>
      );
    case 'unlistedSpaces':
      return (
        <section className={s.contentSection}>
          <UnlistedSpaces buildingId={building.id} />
        </section>
      );
    case 'media':
      return (
        <section className={s.contentSection}>
          <BuildingMediaTable
            buildingId={building.id}
            fetchAdminBuilding={fetchAdminBuilding}
            photos={building.photos}
            video={building.video}
            googleDriveMediaDirectoryId={building.googleDriveMediaDirectoryId}
            googleDriveMediaDirectoryIdTwo={building.googleDriveMediaDirectoryIdTwo}
            firstPhotoOrientation={building.firstPhotoOrientation}
            tourEmbedUrl={building.tourEmbedUrl}
            virtualTourSpotlight={building.virtualTourSpotlight}
            formattedAddress={building.formattedAddress}
          />
        </section>
      );

    case 'contacts':
      return (
        <section>
          <BuildingContacts data={building.listingAgents} onSort={fetchAdminBuilding} />
        </section>
      );
    default:
      return null;
  }
};
export default MenuSwitcher;
